export default __webpack_public_path__ + "assets/images/56be5b3c054ce5056cafc1ae4ef6f569.png";